import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/index";
import Galerie from "./pages/galerie";
import PhotoAlbum from "./pages/photoalbum";
import Novinky from "./pages/novinky";
import Clanek from "./pages/clanek";
import Sluzby from "./pages/sluzby";
import Optometrie from "./pages/sluzby/optometrie";
import Bryle from "./pages/sluzby/bryle";
import Cocky from "./pages/sluzby/cocky";
import Doplnky from "./pages/sluzby/doplnky";
import Reference from "./pages/reference";
import Kontakt from "./pages/kontakt";
import Cookies from "./pages/cookies";
import AutorskaPrava from "./pages/autorska-prava";
import NotFound from "./pages/404";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Note: intentionally not wrapped in React.StrictMode. react-image-lightbox
// (unmaintained) freezes its internal image-load state under StrictMode's
// double-invoked effects in React 18/19 - the lightbox opens on a spinner
// and only shows the photo after a manual next/prev. The reference site
// (tabor-vysocina-web) renders without StrictMode for the same reason.
root.render(
  <Router>
    <ScrollToTop />
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/galerie" element={<Galerie />} />
        <Route path="/galerie/:albumTitle" element={<PhotoAlbum />} />
        <Route path="/novinky" element={<Novinky />} />
        <Route path="/novinky/:articleTitle" element={<Clanek />} />
        <Route path="/sluzby" element={<Sluzby />} />
        <Route path="/sluzby/optometrie" element={<Optometrie />} />
        <Route path="/sluzby/bryle" element={<Bryle />} />
        <Route path="/sluzby/cocky" element={<Cocky />} />
        <Route path="/sluzby/doplnky" element={<Doplnky />} />
        <Route path="/reference" element={<Reference />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/autorska-prava" element={<AutorskaPrava />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
);
